var map = {
	"./avatar-afro-selected.png": 27608,
	"./avatar-guitarbear-selected.png": 62492,
	"./avatar-headphones-selected.png": 31759,
	"./avatar-monocleman-selected.png": 9665,
	"./avatar-radiohead-selected.png": 75503,
	"./avatar-skeleton-selected.png": 9975,
	"./avatar-trumpetman-selected.png": 723,
	"./avatar-violin-selected.png": 22237,
	"./avatar-woman-selected.png": 37292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80365;